import { create } from "zustand";

type AuthState = {
  token: string | null;
  setToken: (token: string) => void;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem("admin_auth_token"),

  setToken: (token) => {
    localStorage.setItem("admin_auth_token", token);
    set({ token });
  },

  clearAuth: () => {
    localStorage.removeItem("admin_auth_token");
    // Clean up the obsolete persisted org from the pre-URL-state structure.
    localStorage.removeItem("admin_active_organisation_id");
    // Drop the remembered org/supplier so the next user doesn't inherit it.
    localStorage.removeItem("admin_last_scope");
    set({ token: null });
  },
}));
